// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #modal-container { */
    /* position: fixed; */
    /* top: 0; */
    /* left: 0; */
    /* right: 0; */
    /* bottom: 0; */
    /* background-color: rgba(0, 0, 0, 0.5); semi-transparent overlay */
    /* z-index: 1000; */
/* } */

#nav-menu-container {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: 0 0 0 auto;
    background-color: #929293;
    font-weight: 600;
    font-size: 20px;
    animation: slideIn 0.3s ease-out forwards;
}

#nav-menu-container.closing {
    animation: slideOut 0.3s ease-out forwards;
}

.close-menu-container {
    width: 100%;
    height: 6rem;
    padding: 2rem 2rem;
    display: flex;
    justify-content: flex-end;
    background-color: #282828;
}

.close-menu-button {
    height: 100%;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.close-menu-button img {
    width: 100%;
    height: 100%;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes slideOut {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(100%);
    }
}

.link-container {
    margin: .5rem auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* animation: dropDown 0.3s ease-out forwards; */
}

.nav-menu-link {
    text-align: center;
    text-decoration: none;
    color: #f0f0f0;
    padding: 1rem 0;
}


/* .nav-menu-link:nth-child(1) { animation-delay: 0.1s; }
.nav-menu-link:nth-child(2) { animation-delay: 0.2s; }
.nav-menu-link:nth-child(3) { animation-delay: 0.3s; } */`, "",{"version":3,"sources":["webpack://./components/NavigationMenu/NavigationMenu.css"],"names":[],"mappings":"AAAA,uBAAuB;IACnB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,eAAe;IACf,mEAAmE;IACnE,mBAAmB;AACvB,MAAM;;AAEN;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;;AAGA;;wDAEwD","sourcesContent":["/* #modal-container { */\n    /* position: fixed; */\n    /* top: 0; */\n    /* left: 0; */\n    /* right: 0; */\n    /* bottom: 0; */\n    /* background-color: rgba(0, 0, 0, 0.5); semi-transparent overlay */\n    /* z-index: 1000; */\n/* } */\n\n#nav-menu-container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0 0 0 auto;\n    background-color: #929293;\n    font-weight: 600;\n    font-size: 20px;\n    animation: slideIn 0.3s ease-out forwards;\n}\n\n#nav-menu-container.closing {\n    animation: slideOut 0.3s ease-out forwards;\n}\n\n.close-menu-container {\n    width: 100%;\n    height: 6rem;\n    padding: 2rem 2rem;\n    display: flex;\n    justify-content: flex-end;\n    background-color: #282828;\n}\n\n.close-menu-button {\n    height: 100%;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.close-menu-button img {\n    width: 100%;\n    height: 100%;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n    }\n    to {\n        transform: translateX(0);\n    }\n}\n\n@keyframes slideOut {\n    from {\n        transform: translateX(0);\n    }\n    to {\n        transform: translateX(100%);\n    }\n}\n\n.link-container {\n    margin: .5rem auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    /* animation: dropDown 0.3s ease-out forwards; */\n}\n\n.nav-menu-link {\n    text-align: center;\n    text-decoration: none;\n    color: #f0f0f0;\n    padding: 1rem 0;\n}\n\n\n/* .nav-menu-link:nth-child(1) { animation-delay: 0.1s; }\n.nav-menu-link:nth-child(2) { animation-delay: 0.2s; }\n.nav-menu-link:nth-child(3) { animation-delay: 0.3s; } */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
